import React from 'react';
import { FileText, CheckCircle, Clock, FileEdit } from 'lucide-react';

const WorksheetNavigation = ({ worksheets, selectedWorksheet, onSelectWorksheet, searchQuery }) => {
  const filteredWorksheets = worksheets?.filter(ws =>
    ws?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    ws?.id?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    ws?.equipment?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return <CheckCircle className="w-4 h-4 text-green-600" />;
      case 'in-progress':
        return <Clock className="w-4 h-4 text-blue-600" />;
      case 'draft':
        return <FileEdit className="w-4 h-4 text-gray-600" />;
      default:
        return <FileText className="w-4 h-4 text-gray-600" />;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-50 text-green-700 border-green-200';
      case 'in-progress':
        return 'bg-blue-50 text-blue-700 border-blue-200';
      case 'draft':
        return 'bg-gray-50 text-gray-700 border-gray-200';
      default:
        return 'bg-gray-50 text-gray-700 border-gray-200';
    }
  };

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="p-4 space-y-2">
        {filteredWorksheets?.map((worksheet) => (
          <button
            key={worksheet?.id}
            onClick={() => onSelectWorksheet(worksheet)}
            className={`w-full text-left p-4 rounded-lg border-2 transition-all ${
              selectedWorksheet?.id === worksheet?.id
                ? 'border-blue-500 bg-blue-50' :'border-gray-200 hover:border-gray-300 bg-white'
            }`}
          >
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center gap-2">
                {getStatusIcon(worksheet?.status)}
                <span className="text-xs font-medium text-gray-600">{worksheet?.id}</span>
              </div>
              <span className={`px-2 py-1 rounded-md text-xs font-medium border ${getStatusColor(worksheet?.status)}`}>
                {worksheet?.status?.replace('-', ' ')?.toUpperCase()}
              </span>
            </div>

            <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2">
              {worksheet?.title}
            </h3>

            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Equipment:</span>
                <span className="font-medium text-gray-900">{worksheet?.equipment}</span>
              </div>

              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Hazards:</span>
                <span className="font-medium text-gray-900">{worksheet?.identifiedHazards}</span>
              </div>

              <div className="mt-3">
                <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
                  <span>Completion</span>
                  <span>{worksheet?.completionRate}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className={`h-2 rounded-full transition-all ${
                      worksheet?.completionRate === 100 ? 'bg-green-600' : 'bg-blue-600'
                    }`}
                    style={{ width: `${worksheet?.completionRate}%` }}
                  />
                </div>
              </div>

              <div className="text-xs text-gray-500 mt-2">
                Modified: {new Date(worksheet.lastModified)?.toLocaleDateString()}
              </div>
            </div>
          </button>
        ))}

        {filteredWorksheets?.length === 0 && (
          <div className="text-center py-8">
            <FileText className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-sm text-gray-600">No worksheets found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorksheetNavigation;